// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___3wnXM","content":"styles__content___3G90d"};